import { render, staticRenderFns } from "./GeneralTab.vue?vue&type=template&id=7edc7546&"
import script from "./GeneralTab.vue?vue&type=script&lang=ts&"
export * from "./GeneralTab.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports